import React, { useState } from 'react';
import CustomButton from '../../Components/CommonComp/Buttons/CustomButton';
import MainLayout from '../Layouts/MainLayout';
import ReceiverParty from './ReceiverParty';
import { useNavigate } from 'react-router-dom';

function ReceiverPartyContainer() {
  const [navParams, setNavParams] = useState({
    navTitle: 'All Receiver Party Data',
    navSubTitle: 'Welcome to Classy Vouge',
  });
  const navigate = useNavigate();
  const [addUserModal, setAddUserModal] = useState(false);
  const handleAddUserModal = (value = false) => {
    setAddUserModal(value);
  };
  const handleNavParams = (obj) => {
    setNavParams({
      ...navParams,
      ...obj,
    });
  };
  return (
    <MainLayout
      navTitle={navParams.navTitle}
      navSubTitle={navParams.navSubTitle}
      navBarRightComp={
        <CustomButton
          sx={{ padding: '12px 15px', ml: (theme) => theme.spacing(2) }}
          color={'buttonPrimary'}
          onClick={() => navigate('/receiver/addReceiver')}
        >
          Add Receiver Party
        </CustomButton>
      }
    >
      <ReceiverParty
        handleNavParams={handleNavParams}
        addUserModal={addUserModal}
        handleAddUserModal={handleAddUserModal}
      />
    </MainLayout>
  );
}

export default ReceiverPartyContainer;
